export const SEARCH_PARAM_KEYS = {
  COMPARE_BY: 'compare_by',
  QUESTION_OPTION: 'option_ids',
  QUOTA_GROUP: 'group_ids',
};
